<template>

  <v-card class="dashboardcontent">

    <v-card-actions>  
    <v-btn      
      icon
      :to="'/'+$home+'content/resp'"
      >      
      <v-icon>mdi-table-of-contents</v-icon>
    </v-btn>
    </v-card-actions>    

  <v-list-item two-line>
      <v-list-item-icon
        class="dash-icon"
        >
        <v-icon
          size="24"          
          >mdi-account-details-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="d-title">
          Verantwortliche / Experten
        </v-list-item-title>        
      </v-list-item-content>
    </v-list-item>
  
  <v-data-table
      v-model="selected"
      :headers="headers"
      :items="resps"
      :items-per-page="5"
      :footer-props="{
        'disable-items-per-page': true        
      }"      
      :single-select="singleSelect"
      :search="search"
      item-key="id"
      class="list-blank elevation-1"      
    >

    <template v-slot:body="{ items }">
      <tbody>
        <tr
          v-for="(item) in items"
          :key="item.id"
        >
          <td>{{ item.id }}</td>
          <td>
            <router-link :to="'/'+$home+'node/resp/' + item.id" text small>
            {{ item.name }}
            </router-link>
          </td>                                             
          <td>
            {{ item.organisation }}
          </td>
          <td>
            {{ item.department }}
          </td>          
        </tr>
      </tbody>
    </template>

  </v-data-table>

  </v-card>
</template>

<script>
export default {
  name: 'DashboardUsecases',  
  props: ['type'],
  data () {
    return {
      singleSelect: false,
      selected: [],
      search: '',
      headers: [
        { text: 'ID',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Organisation',
          value: 'organisation'
        },
        {
          text: 'Bereich',
          value: 'department'
        }        
      ],
      resps: []      
    }
  },
  methods: {
      getResps() {
          this.axios.get( this.$config.host+"/resps" ).then(response => (
            this.resps = response.data
          ));
      }
  },
  mounted() {    
    this.getResps();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.list-blank .v-data-footer {
    padding: 6px 8px;
 
}
.list-blank .v-data-footer__select {
  display:none;  
}
</style>
